import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import SiteLayout from '../../../layouts/SiteLayout/SiteLayout';
import BookingClosedSection from '../../../paymentJourney/BookingClosedSection/BookingClosedSection';

export function BookingClosedView({ t, siteHeader }) {
  const { meta: { title: metaTitle } = {}, data: { title: dataTitle } = {} } =
    siteHeader || {};
  const title = metaTitle || dataTitle;
  const helmetTitle = title
    ? `${t('event.purchase.booking-closed')} | ${title}`
    : t('event.purchase.booking-closed');

  return (
    <SiteLayout helmet={{ title: helmetTitle }} footerUpperHidden>
      <BookingClosedSection />
    </SiteLayout>
  );
}

BookingClosedView.propTypes = {
  siteHeader: PropTypes.shape({
    data: PropTypes.shape({
      title: PropTypes.string,
    }),
    meta: PropTypes.shape({
      title: PropTypes.string,
    }),
  }),
};

function mapStateToProps(state) {
  return {
    siteHeader: state.siteHeader,
  };
}

export default withTranslation()(connect(mapStateToProps)(BookingClosedView));
